function decodeToken(str) {
  str = str.split('.')[1]

  str = str.replace(/-/g, '+')
  str = str.replace(/_/g, '/')
  switch (str.length % 4) {
    case 0:
      break
    case 2:
      str += '=='
      break
    case 3:
      str += '='
      break
    default:
      throw 'Invalid token'
  }

  str = decodeURIComponent(escape(atob(str)))

  str = JSON.parse(str)
  return str
}

export const getStorageTokens = () => {
  return localStorage.getItem('keycloak_data')
    ? JSON.parse(localStorage.getItem('keycloak_data'))
    : {}
}

export const updateToken = (keycloak, validity = -1) => {
  keycloak
    .updateToken(validity)
    .then(() => {})
    .catch(() => {})
}

export function updateKeycloakToken(
  keycloak,
  accessToken,
  idToken,
  refreshToken
) {
  if (accessToken) {
    keycloak.token = accessToken
    keycloak.tokenParsed = decodeToken(accessToken)
    keycloak.sessionId = keycloak.tokenParsed.session_state
    keycloak.authenticated = true
    keycloak.subject = keycloak.tokenParsed.sub
    keycloak.realmAccess = keycloak.tokenParsed.realm_access
    keycloak.resourceAccess = keycloak.tokenParsed.resource_access
  }

  if (idToken) {
    keycloak.idToken = idToken
    keycloak.idTokenParsed = decodeToken(idToken)
  }

  if (refreshToken) {
    keycloak.refreshToken = refreshToken
    keycloak.refreshTokenParsed = decodeToken(refreshToken)
  }

  localStorage.setItem('current_company', null)
}
